import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { DivisionTblDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-division-container',
  templateUrl: './division-container.component.html',
  styleUrls: ['./division-container.component.scss']
})
export class DivisionContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  divisions$: Observable<DivisionTblDto[]>;
  loading: boolean;
  isLoadingDivision$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingDivision$ = this.gatwayFacade.isLoadingGateway("DivisionTbl");
    this.divisions$ = this.gatwayFacade.loadGateway("DivisionTbl");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteDivision(deletedValue: any) {
    this.gatwayFacade.remove("DivisionTbl", deletedValue);
  }


// this method control both the create and update

  onSubmitDivision(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Divisions;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllDivision = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllDivision.push(pullData[i]);
    }
  }

// check if the addAllDivision array is not empty, then dispatch the data to the store
   if(addAllDivision.length > 0) {
    this.gatwayFacade.add('DivisionTbl', addAllDivision);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('DivisionTbl', allUpdates, ['id']);
  }

   }


}
